<template>
  <div class="container">
    <el-row class="common-box">
      <div class="common-search">
        <el-form ref="formData" :model="formData" :inline="true" label-width="90px" class="formInline" size="mini">
          <el-form-item label="客户名称" prop="customer">
            <el-select v-model="formData.customer" filterable placeholder="请选择客户名称...">
              <el-option label="不限" :value="null"></el-option>
              <el-option v-for="item in allCustomers" :key="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="公司名称" prop="company">
            <el-select v-model="formData.company" filterable placeholder="请选择公司名称...">
              <el-option label="不限" :value="null"></el-option>
              <el-option v-for="item in allCompany" :label="item.name" :key="item.code" :value="item.code"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="签约平台" prop="serviceSupplier">
            <el-select v-model="formData.serviceSupplier" filterable placeholder="请选择签约平台...">
              <el-option label="不限" :value="null"></el-option>
              <!-- <el-option label="众简" value="众简"></el-option>
              <el-option label="薪太软" value="薪太软"></el-option> -->
              <el-option :label="item" :value="item" v-for="item in serviceSuppliers"
                           :key="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="服务商" prop="serviceId">
            <el-select v-model="formData.serviceId" filterable placeholder="请选择服务商...">
              <el-option label="不限" :value="null"></el-option>
              <el-option v-for="item in allService" :label="item.name" :key="item.code" :value="item.code"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="落地方" prop="supplierId">
            <el-select v-model="formData.supplierId" filterable placeholder="请选择落地方...">
              <el-option label="不限" :value="null"></el-option>
              <el-option v-for="item in allSupplier" :label="item.name" :key="item.code" :value="item.code"></el-option>
            </el-select>
          </el-form-item>
          <hr style="margin-bottom: 9px;">
          <div class="slide-btns clearfix">
            <el-form-item>
              <el-button type="text" class="reset-btn" @click="resetForm">清空</el-button>
              <el-button class="search-btn" @click="submitForm">筛选</el-button>
              <!-- <el-button class="search-btn" style="margin-left: 0px;" @click="exportExcel">导出</el-button> -->
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="common-box-body">
        <el-table :data="tableData" size="small" v-loading="listLoading" element-loading-text="拼命加载中" border
                  style="width: 100%" header-row-class-name="table-header">
          <el-table-column type="index" label="#" width="50" align="center"></el-table-column>
          <el-table-column prop="customerName" label="客户名称" align="center"></el-table-column>
          <el-table-column prop="companyName" label="公司名称" align="center"></el-table-column>
          <el-table-column prop="companyCode" label="公司编号" align="center"></el-table-column>
          <el-table-column prop="serviceNm" label="服务商" align="center"></el-table-column>
          <el-table-column prop="serviceSupplier" label="签约平台" align="center"></el-table-column>
          <el-table-column prop="supplierName" label="落地方" align="center"></el-table-column>
          <el-table-column prop="suffix" label="当前期任务批次" align="center"></el-table-column>
          <el-table-column prop="contractName" label="当前期合同任务名称" align="center"></el-table-column>
          <el-table-column prop="nextSuffix" label="下一期任务批次" align="center"></el-table-column>
          <el-table-column prop="nextContractName" label="下一期合同任务名称" align="center"></el-table-column>
          <el-table-column prop="updateTime" label="更新时间" align="center"></el-table-column>
          <el-table-column prop="operatorAccount" label="操作者账号" align="center"></el-table-column>
          <el-table-column prop="operatorName" label="操作者姓名" align="center"></el-table-column>
          <el-table-column v-if="editAuth" label="操作" align="center">
            <template slot-scope="scope">
              <span style="color: #1652ff; cursor: pointer;" @click="openEditDialog(scope.row.id, scope.row.customerName, scope.row.suffix, scope.row.nextSuffix)">修改</span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination class="pagination table-pagination"
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page="formData.pageNo"
                       :page-sizes="[10, 20, 30, 40]"
                       :page-size="formData.pageSize"
                       layout="slot, total, sizes, prev, pager, next, jumper"
                       :total="total">
        </el-pagination>
      </div>
    </el-row>
    <el-dialog :title="'修改任务批次：' + editCustomer" :visible.sync="showEditDialog" width="30%" center>
      <hr style="margin-bottom: 9px">
      <div style="text-align: center; margin-top: 50px;">
        <div>
          <div style="text-align:left;margin-bottom:10px;">当前期任务批次：</div>
          <div><el-input v-model="editSuffix"></el-input></div>
        </div>
        <div>
          <div style="text-align:left;margin-bottom:10px;margin-top:20px;">下一期任务批次：</div>
          <div><el-input v-model="nextEditSuffix"></el-input></div>
        </div>
        
        <div style="text-align:center;margin-top:30px;">
          <el-button class="search-btn" @click="editCustomerConfig">确定</el-button>
          <el-button class="search-btn" @click="showEditDialog=false">取消</el-button>
        </div>
      </div>

    </el-dialog>
  </div>
</template>

<script>
  import utils from '../../common/js/util.js'

  export default {
    data() {
      return {
        allCustomers: [],
        allCompany: [],
        allService: [],//服务商
        allSupplier: [],//落地方
        formData: {
          pageNo: 1,
          pageSize: 10,
          customer: null,
          company: null,
          serviceSupplier: null,
          serviceId: null,
          supplierId: null
        },
        tableData: [],
        total: null,
        listLoading: false,
        editId: null,
        editCustomer: null,
        showEditDialog: false,
        editSuffix: null,
        nextEditSuffix: null,
        editAuth: false,
        serviceSuppliers: []
      }
    },
    mounted() {
      this.getEditCustomerConfigAuth();
      this.searchAllCustomer();
      this.searchAllCompany();
      this.getData();
      this.getServiceSuppliers();
      this.searchAllServiceSupplier('落地方');
      this.searchAllServiceSupplier('服务商');
    },
    methods: {
      getData() {
        this.listLoading = true;
        this.$http({
          method: 'GET',
          url: '/rest/customer/list',
          params: this.formData
        }).then(res => {
          this.tableData = res.data.data.items;
          this.total = res.data.data.totalItemsCount;
          this.listLoading = false;
        }).catch(err => {
          this.listLoading = false;
        })
      },
      searchAllCustomer() {
        this.$http({
          method: 'GET',
          url: '/rest/baseCenter/all-customers'
        }).then(res => {
          this.allCustomers = res.data.data
        }).catch(err => {
        })
      },
      searchAllCompany() {
        this.$http({
          method: 'GET',
          url: '/rest/customer/company-list'
        }).then(res => {
          this.allCompany = res.data.data
        }).catch(err => {
        })
      },  
      searchAllServiceSupplier(typeName) {
        this.$http({
          method: 'GET',
          url: '/rest/customer/service-supplier',
          params: {
            typeName: typeName
          }
        }).then(res => {
          if(typeName == '服务商'){
            this.allService = res.data.data
          }else if(typeName == '落地方'){
            this.allSupplier = res.data.data
          }
        }).catch(err => {
        })
      },
      submitForm() {
        this.formData.pageSize = 10;
        this.formData.pageNo = 1;
        this.getData();
      },
      exportExcel() {
        this.listLoading = true;
        this.$http({
          method: 'GET',
          url: '/rest/customer/export',
          params: this.formData
        }).then(res => {
          if(res.data && res.data.status == 200) {
            this.listLoading = false;
            location.href = utils.returnUrlHead() + res.data.data;
          }else {
            this.listLoading = false;
            this.$alert(res.data.message);
          }
        }).catch(error => {
          this.listLoading = false;
          this.$alert("导出错误，请联系管理员！");
        });
      },
      resetForm() {
        this.$refs['formData'].resetFields();
      },
      handleSizeChange(val) {
        this.formData.pageSize = val;
        this.getData();
      },
      handleCurrentChange(val) {
        this.formData.pageNo = val;
        this.getData();
      },
      openEditDialog(id, customer, suffix, nextSuffix) {
        this.editId = id;
        this.editCustomer = customer;
        this.showEditDialog = true;
        this.editSuffix = suffix;
        this.nextEditSuffix = nextSuffix;
      },
      editCustomerConfig() {
        this.$http({
          method: 'POST',
          url: '/rest/customer/edit',
          params: {
            id: this.editId,
            suffix: this.editSuffix,
            nextSuffix: this.nextEditSuffix
          }
        }).then(res => {
          this.showEditDialog = false;
          utils.myNotify(this, "success", res, '操作成功');
          this.getData();
        }).catch(err => {
          utils.myNotify(this, "error", res, '操作失败');
        })
      },
      getEditCustomerConfigAuth() {
        this.$http({
          method: 'GET',
          url: '/rest/customer/edit-auth'
        }).then(res => {
          this.editAuth = res.data.data
        }).catch(err => {
        })
      },
      getServiceSuppliers() {
        this.$http({
          method: 'GET',
          url: '/rest/JiangYiJoint/getServiceSuppliers',
          
        }).then(res => {
          this.serviceSuppliers = res.data
        }).catch(err => {
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .search-btn {
    margin-left: 30px;
    margin-right: 30px;
  }
</style>




// WEBPACK FOOTER //
// src/views/personnelCenter/customerConfig.vue